<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="useBtnList"
                    @btnRetrieve="btnRetrieve()" @btnPrint="btnPrint()" @btnSaveExcel="btnSaveExcel()"
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <i-label :label="'Ship No : '"/>
                        <v-col cols="1">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="changeShipNo"
                          ></v-select>
                        </v-col>
                        <i-label :label="'Rev.No : '" class="pl-2"/>
                        <v-col cols="1" >
                          <v-text-field 
                            v-model="revNo" 
                            dense 
                            outlined 
                            hide-details="auto"
                          />
                        </v-col>
                        <i-label :label="'Block : '" class="pl-2"/>
                        <v-col cols="1">
                          <v-select
                            v-model="block"
                            :items="blockList"
                            item-value="block"
                            return-object
                            single-line
                            outlined
                            dense
                            :label="'All'"
                            @change="btnRetrieve()"
                          ></v-select>
                        </v-col>
                        <i-label :label="'Set Point : '" class="pl-2"/>
                        <v-col cols="1">
                          <v-select
                            v-model="setPoint"
                            :items="setPointList"
                            item-value="setPoint"
                            return-object
                            single-line
                            outlined
                            dense
                            :label="'All'"
                            @change="btnRetrieve()"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms6400" 
                    :ref="epms6400Ref"
                    class="hipGridHeight1_1"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                  >
                    <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="number" format="0,###" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="drumNo" caption="Drum No." width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="cableType" width="6%" data-type="string" alignment="center" header-cell-template="cableType" :allow-editing="false" />
                    <template #cableType>
                      <div>Cable<br>Type</div>
                    </template>
                    <DxColumn data-field="sys" caption="SYS" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="feedNo" caption="Feed No." width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="length" caption="Length" width="4%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="frLen" width="4%" data-type="string" alignment="center" header-cell-template="fLength" :allow-editing="false" />
                    <template #fLength>
                      <div>From<br>Length</div>
                    </template>
                    <DxColumn data-field="toLen" width="4%" data-type="string" alignment="center" header-cell-template="tLength" :allow-editing="false" />
                    <template #tLength>
                      <div>To<br>Length</div>
                    </template>
                    <DxColumn data-field="setPnt" width="5%" data-type="string" alignment="center" header-cell-template="setPoint" :allow-editing="false" />
                    <template #setPoint>
                      <div>Set<br>Point</div>
                    </template>
                    <DxColumn caption="From" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="frDeck" caption="Deck" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="frEqp" caption="Equipment" width="20%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="To" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="toDeck" caption="Deck" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="toEqp" caption="Equipment" width="20%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="rmk" caption="Remark" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getShipList , getBlkList , getSetPointList , getRevNo , epms6400List , epms6400Xls } from '@/api/view/hip/6/epms6400.js'
import { reportView} from '@/api/view/hip/common/common.js'

export default {
  name: 'epms6400',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' , 'btnPrint' , 'btnSaveExcel'],
      epms6400Ref: 'epms6400Ref',
      gridMainList: [],

      shipNo: '',
      shipNoList: [],
      revNo: '',
      block: 'All',
      blockList: [],
      setPoint: 'All',
      setPointList: []
      
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms6400Ref)
    },
  },
  mounted() {
    this.shipList()
    
  },
  methods: {
    async shipList(){
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
        }
        await getShipList(params).then(res => {
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
        })
      } finally {
      this.endLoading()
      }
    },

    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo,
        }
        await getBlkList(params).then(res => {
          this.blockList.push('All')
          res.list.forEach(e => {
            this.blockList.push(e.block)
          });
        })

        await getSetPointList(params).then(res => {
          this.setPointList.push('All')
          res.list.forEach(e => {
            this.setPointList.push(e.setPoint)
          });
        })

        await getRevNo(params).then(res => {
          if(res.list.length > 0){
            this.revNo = res.list[0].revNo
          }
        })
      } finally {
      this.endLoading()
      }
    },
    async epms6400List(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo,
          block: this.block === 'All' ? '' : this.block,
          setPoint: this.setPoint === 'All' ? '' : this.setPoint
        }
        await epms6400List(params).then(res => {
          res.list.forEach(e => {
            e.id = e.rnum
          });
          this.gridMainList = res.list
        })

      } finally {
      this.endLoading()
      }
    },
    changeShipNo(e){
      this.blockList = []
      this.setPointList = []
      this.getList()

    },
    btnRetrieve(){
      if(!this.block || this.block === '' || !this.setPoint || this.setPoint === ''){
        this.vToastify(this.$t('Please select Block or Setpoint!'), 'warn')
        return
      }
      this.epms6400List()
    },
    btnPrint(){
      const param = {
        fileName: 'epms6400prt.jrxml',
        as_ship_no: this.shipNo,
        as_block: this.block === 'All' ? '' : this.block,
        as_set_point: this.setPoint === 'All' ? '' : this.setPoint,
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnSaveExcel(){
      const param = {
        shipNo: this.shipNo,
        makerCd: this.$store.state.user.makerCd,
        block: this.block === 'All' ? '' : this.block,
        setPoint: this.setPoint === 'All' ? '' : this.setPoint
      }
      epms6400Xls(param)
    },
  }
}
</script>
<style lang="scss" scoped>
</style>